import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import Realtor from '../../static/biz-professional/business-962364_1280.jpeg';
import Cards from '../../static/biz-professional/pants-1826127_1280.jpeg';
import Sim from '../../static/biz-professional/sim-card-1645646_1280.png';
import Yen from '../../static/biz-professional/10000.jpeg';
import Sushi from '../../static/biz-professional/sushi.jpeg';
import Code from '../../static/biz-professional/code.jpeg';
import RealEstate from '../../static/biz-professional/tokyo-3790323_1280.jpeg';
import Others from '../../static/biz-professional/bonsai-4634225_1280.jpeg';
import Bank from '../../static/biz-professional/payment-4399011_1280.jpeg';
import Keyboard from '../../static/biz-professional/webdesign-4566239_1280.jpeg';
import Stars from '../../static/biz-professional/star-trails-1846734_1280.jpeg';
import Semiconductor from '../../static/biz-professional/capacitors-5367873_1280.jpeg';
import Teapot from '../../static/biz-professional/teapot-6123749_1280.jpeg';
import Telephone from '../../static/biz-professional/telephone-pole-4831693_1280.jpeg';
import Shibuya from '../../static/biz-professional/shibuyasky-4768679_1280.jpeg';
import Tori from '../../static/biz-professional/tori-1976609_1280.jpeg';
import Gold from '../../static/biz-professional/japan-7144548_1280.jpeg';
import Bonsai from '../../static/biz-professional/black-4480596_1280.jpeg';
import Bonsai5 from '../../static/biz-professional/bonsai-4634225_1280.jpeg'
import Hanabi from '../../static/biz-professional/fireworks-8182800_1280.jpeg';
import { useNavigate } from 'react-router-dom';

import { UI_ISSUE, UI_COFFEE_BREAK, UI_BOOK2, UI_CREDIT_CARD, UI_HER, UI_EC, UI_MOBILE_CARRIER, UI_FURNITURE_AND_ELECTRONICS, UI_OTHERS, UI_SLIDE_STRUCTURE, UI_TOP_MESSAGE, UI_DESIGN, UI_BOTTOM, UI_SUMMARY, UI_PRESENTATIONS, UI_PROFESSIONAL_BOOKS, UI_EPILOGUE } from '../../consts';


const ImageBackdrop = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  background: '#000',
  opacity: 0.5,
  transition: theme.transitions.create('opacity'),
}));

const ImageIconButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  display: 'block',
  padding: 0,
  borderRadius: 0,
  height: '40vh',
  [theme.breakpoints.down('md')]: {
    width: '100% !important',
    height: 100,
  },
  '&:hover': {
    zIndex: 1,
  },
  '&:hover .imageBackdrop': {
    opacity: 0.15,
  },
  '&:hover .imageMarked': {
    opacity: 0,
  },
  '&:hover .imageTitle': {
    border: '4px solid currentColor',
  },
  '& .imageTitle': {
    position: 'relative',
    padding: `${theme.spacing(2)} ${theme.spacing(4)} 14px`,
  },
  '& .imageMarked': {
    height: 3,
    width: 18,
    background: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
}));

const images = [
  {
    // url: 'https://images.unsplash.com/photo-1534081333815-ae5019106622?auto=format&fit=crop&w=400',
    image: `url(${Shibuya})`,
    title: '1. イシューを洗い出そう。そして、構造化しよう。',
    width: '40%',
    path: UI_ISSUE,
  },
  {
    // url: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&w=400',
    image: `url(${Gold})`,
    title: '2. 1スライドの中の基本構成を固めよう',
    width: '30%',
    path: UI_SLIDE_STRUCTURE,
  },
  {
    // url: 'https://images.unsplash.com/photo-1453747063559-36695c8771bd?auto=format&fit=crop&w=400',
    image: `url(${Bank})`,
    title: '3. 1スライド1メッセージのルール（スライドのメッセージは何か）',
    width: '30%',
    path: UI_TOP_MESSAGE,
  },
  {
    // url: 'https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0?auto=format&fit=crop&w=400',
    image: `url(${Hanabi})`,
    title: '4. デザインの話。色は情報である。そして線も情報である。',
    width: '30%',
    path: UI_DESIGN,
  },
  {
    // url: 'https://images.unsplash.com/photo-1531299204812-e6d44d9a185c?auto=format&fit=crop&w=400',
    image: `url(${Tori})`,
    title: '5. トップメッセージとボトムメッセージを使いわけよう（中級）',
    width: '35%',
    path: UI_BOTTOM,
  },
  {
    // url: 'https://images.unsplash.com/photo-1523309996740-d5315f9cc28b?auto=format&fit=crop&w=400',
    image: `url(${Keyboard})`,
    title: '6. （テンプレート付き）エグゼクティブサマリーを作ろう（中級）',
    width: '35%',
    path: UI_SUMMARY,
  },
  {
    // url: 'https://images.unsplash.com/photo-1506941433945-99a2aa4bd50a?auto=format&fit=crop&w=400',
    image: `url(${Teapot})`,
    title: '7. 実例から学ぼう。トップティア戦コンの実際のプレゼン資料',
    width: '40%',
    path: UI_PRESENTATIONS,
  },
  {
    // url: 'https://images.unsplash.com/photo-1518136247453-74e7b5265980?auto=format&fit=crop&w=400',
    image: `url(${Bonsai5})`,
    title: '番外編: ビジネスプロフェッショナルの必読書5選。世界で通用する共通言語を学ぶ。',
    width: '40%',
    path: UI_PROFESSIONAL_BOOKS,
  },
  {
    // url: 'https://images.unsplash.com/photo-1533727937480-da3a97967e95?auto=format&fit=crop&w=400',
    image: `url(${Bonsai})`,
    title: 'エピローグ: 監修者からのメッセージ',
    width: '20%',
    path: UI_EPILOGUE,
  },
];

export default function ProductCategories() {
  const navigate = useNavigate()
  const handleImageClick = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  return (
    <Container component="section" sx={{ mt: 8, mb: 4 }}>
      <Typography variant="h1" align="center" sx={{ fontSize: 40, fontWeight: 'normal' }}>
        プレゼンテーションのマストスキル獲得への7ステップ
      </Typography>
      <Typography variant="h5" sx={{ fontSize: 20, marginTop: 5 }}>
        プレゼンテーションのスキル獲得に向けた重要な7つのステップをご紹介します。理論と実践の双方の側面から、重要なポイントを説明しています。
        戦略コンサルティングファームをはじめとするプロフェッショナルファームの若手が学ぶ内容となっており、
        ビジネスプロフェッショナルのプレゼンテーションスキル獲得におけるバイブルとなれば幸いです。

      </Typography>
      <Box sx={{ mt: 8, display: 'flex', flexWrap: 'wrap' }}>
        {images.map((image) => (
          <ImageIconButton
            key={image.title}
            style={{
              width: image.width,
            }}
            onClick={() => handleImageClick(image.path)}
          >
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundSize: 'cover',
                backgroundPosition: 'center 40%',
                // backgroundImage: `url(${image.url})`,
                backgroundImage: image.image,
              }}
            />
            <ImageBackdrop className="imageBackdrop" />
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'common.white',
              }}
            >
              <Typography
                component="h3"
                variant="h6"
                color="inherit"
                className="imageTitle"
              >
                {image.title}
                <div className="imageMarked" />
              </Typography>
            </Box>
          </ImageIconButton>
        ))}
      </Box>
      {/* <Typography variant="h5" marked="center" align="center" sx={{ fontSize: 20, marginTop: 5 }}>
        リンクの一部はアフィリエイトリンク/広告です。
      </Typography> */}
    </Container>
  );
}
